import React, { useEffect, useRef } from 'react';
import anime from 'animejs';

// Ambient SVG shapes drifting in front of the background.
const FloatingShapes = ({ className = '' }) => {
    const ref = useRef(null);

    useEffect(() => {
        const root = ref.current;
        if (!root) return;
        const shapes = root.querySelectorAll('.fl-shape');
        const animations = [];

        shapes.forEach((s, i) => {
            const a = anime({
                targets: s,
                translateY: [
                    { value: anime.random(-30, 30), duration: anime.random(3500, 6500) },
                    { value: anime.random(-30, 30), duration: anime.random(3500, 6500) },
                ],
                translateX: [
                    { value: anime.random(-20, 20), duration: anime.random(3500, 6500) },
                    { value: anime.random(-20, 20), duration: anime.random(3500, 6500) },
                ],
                rotate: '+=360',
                duration: anime.random(8000, 16000),
                easing: 'easeInOutSine',
                loop: true,
                direction: 'alternate',
                delay: i * 120,
            });
            animations.push(a);
        });

        return () => animations.forEach((a) => a.pause());
    }, []);

    return (
        <div ref={ref} className={`absolute inset-0 pointer-events-none ${className}`} aria-hidden="true">
            <svg className="absolute top-[8%] left-[6%] w-10 h-10 fl-shape" viewBox="0 0 40 40">
                <polygon points="20,2 38,38 2,38" fill="none" stroke="#ff5252" strokeWidth="1.2" opacity="0.7" />
            </svg>
            <svg className="absolute top-[18%] right-[10%] w-14 h-14 fl-shape" viewBox="0 0 40 40">
                <rect x="6" y="6" width="28" height="28" fill="none" stroke="#fff" strokeWidth="1" opacity="0.25" />
            </svg>
            <svg className="absolute top-[55%] left-[12%] w-8 h-8 fl-shape" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="14" fill="none" stroke="#ff2a2a" strokeWidth="1.2" opacity="0.6" />
            </svg>
            <svg className="absolute top-[65%] right-[8%] w-12 h-12 fl-shape" viewBox="0 0 40 40">
                <path d="M20 4 L36 20 L20 36 L4 20 Z" fill="none" stroke="#fff" strokeWidth="1" opacity="0.3" />
            </svg>
            <svg className="absolute top-[35%] left-[40%] w-6 h-6 fl-shape" viewBox="0 0 40 40">
                <path d="M8 20 H32 M20 8 V32" stroke="#ff5252" strokeWidth="2" opacity="0.5" />
            </svg>
            <svg className="absolute top-[80%] left-[55%] w-10 h-10 fl-shape" viewBox="0 0 40 40">
                <polygon points="20,4 36,20 20,36 4,20" fill="#ff2a2a" opacity="0.18" />
            </svg>
            <svg className="absolute top-[12%] left-[55%] w-9 h-9 fl-shape" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="3" fill="#ff5252" opacity="0.8" />
                <circle cx="20" cy="20" r="12" fill="none" stroke="#ff5252" strokeWidth="0.8" opacity="0.5" />
            </svg>
            <svg className="absolute top-[42%] right-[18%] w-7 h-7 fl-shape" viewBox="0 0 40 40">
                <rect x="10" y="10" width="20" height="20" fill="#fff" opacity="0.12" transform="rotate(45 20 20)" />
            </svg>
        </div>
    );
};

export default FloatingShapes;
